<template>
  <div class="diseaseList">
    <!-- 筛选查询框 @change="selectGoodsByIdBtn"-->
    <el-form :inline="true">
      <!-- <el-button type="primary" size="small" v-waves @click="handleAdd">新增</el-button> -->
      <el-form-item label="公众号openid: " style="margin:0 20px" size="small">
        <el-input v-model="listQuery.gzh_openid" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="getListData" size="small" v-waves>搜索</el-button>
    </el-form>
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="template_id" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini">
            {{
            arrayByIdToNameStr({
            ArrayData: templateList,
            ID: row.template_id,
            })
            }}
          </el-tag>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <!-- <el-button size="mini" type="text" @click="handleEdit(row)" primary>编辑</el-button> -->
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0);"
              @click="handleDelete(row)"
            >删除</el-button>
          </div>
        </template>
      </ElTable>

      <!-- 产品提交表单 -->
      <el-dialog
        :title="inpitTypeName"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form ref="form" :model="dialogForm" label-width="120px">
          <el-form-item label="公众号名称" required>
            <el-input v-model="dialogForm.account_name" clearable></el-input>
          </el-form-item>
          <el-form-item label="appid" required>
            <el-input v-model="dialogForm.appid" clearable></el-input>
          </el-form-item>
          <el-form-item label="appsecret" required>
            <el-input v-model="dialogForm.appsecret" clearable></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  selectApi,
  updateApi,
  deleteApi,
  addApi
} from "@/services/sendService/sendRecord";
import ElTable from "@/components/elTable/index.vue";
import StoreToString from "@/components/filters/storeToString.vue";
import listHeader from "./listHeader";
import { mapState } from "vuex";
import { selectApi as selectTemplateApi } from "@/services/sendService/sendTemplate";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";
export default {
  components: {
    ElTable,
    StoreToString
  },
  created() {
    this.getListData();
    this.getTemplateData();
  },

  data() {
    return {
      arrayByIdToNameStr,
      loading: false,
      listQuery: {
        type: 1,
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },

      tableData: [],

      dialogFormVisible: false,
      inpitTypeName: "",

      dialogForm: {},
      templateList: []
    };
  },
  computed: {
    listHeader,
    ...mapState(["userInfo", "filterStoreList"])
  },
  watch: {},
  methods: {
    async getTemplateData() {
      const { data, code, count } = await selectTemplateApi({
        pageNumber: 1,
        pageSize: 1000
      });
      if (code === 200) {
        this.templateList = data.map(item => {
          return {
            ...item,
            name: item.template_name
          };
        });
      }
    },
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.store_id =
        listQuery.store_id?.join(",") || this.userInfo.store_id;
      this.loading = true;
      const { data, code, count } = await selectApi(listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    handleAdd(type) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "新增";
      this.dialogForm = {};
    },

    /* 修改 */
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "修改";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    /* 保存 */
    save() {
      //必填字段校验
      if (
        !this.dialogForm.account_name ||
        !this.dialogForm.appid ||
        !this.dialogForm.appsecret
      ) {
        this.$message.error("请填写必填字段");
        return;
      }
      if (this.inpitTypeName == "新增") {
        addApi({ ...this.dialogForm }).then(res => {
          console.log(res);
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "新增成功!"
            });
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
      if (this.inpitTypeName == "修改") {
        updateApi(this.dialogForm).then(resp => {
          console.log(resp);
          if (resp.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!"
            });
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm(`此操作将永久删除该记录吗, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteApi({ id: row.id }).then(res => {
            console.log(res);
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.diseaseList {
  width: 100%;
}
.tableList {
  border-radius: 6px;
  background: #fff;
  /* max-width: 1405px; */
  margin: 10px auto;
}
</style>
